module.exports = __webpack_public_path__ + "img/2.8e5c9b78.png";